import React from 'react';

interface Props {
  page: number;
  total: number;
  pageSize: number;
  onChange: (page: number) => void;
}

const Pagination: React.FC<Props> = ({ page, total, pageSize, onChange }) => {
  const pages = Math.ceil(total / pageSize);
  if (pages <= 1) return null;

  const items: (number | '...')[] = [];
  if (pages <= 7) {
    for (let i = 1; i <= pages; i++) items.push(i);
  } else {
    items.push(1);
    if (page > 3) items.push('...');
    for (let i = Math.max(2, page - 1); i <= Math.min(pages - 1, page + 1); i++) items.push(i);
    if (page < pages - 2) items.push('...');
    items.push(pages);
  }

  return (
    <div className="lib-pagination">
      <button className="lib-page-btn" disabled={page === 1} onClick={() => onChange(page - 1)}>
        ‹
      </button>
      {items.map((item, idx) =>
        item === '...' ? (
          <span key={`ellipsis-${idx}`} className="lib-page-ellipsis">…</span>
        ) : (
          <button
            key={item}
            className={`lib-page-btn${item === page ? ' lib-page-btn--active' : ''}`}
            onClick={() => onChange(item as number)}
          >
            {item}
          </button>
        )
      )}
      <button className="lib-page-btn" disabled={page === pages} onClick={() => onChange(page + 1)}>
        ›
      </button>
    </div>
  );
};

export default Pagination;
